import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable()
export class StorageService {
  private localStorageWithFallback;
  private sessionStorageWithFallback;

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.localStorageWithFallback = this.safeLocalStorage();
      this.sessionStorageWithFallback = this.safeSessionStorage();
    }
  }

  save(key: string, data: any, session?: boolean): void {
    if (isPlatformBrowser(this.platformId)) {
      if (session && this.sessionStorageWithFallback) {
        this.sessionStorageWithFallback.setItem(key, JSON.stringify(data));
      } else if (this.localStorageWithFallback) {
        this.localStorageWithFallback.setItem(key, JSON.stringify(data));
      }
    }
  }

  read(key: string, session?: boolean): any {
    let data: any = null;
    if (isPlatformBrowser(this.platformId)) {
      if (session && this.sessionStorageWithFallback) {
        data = JSON.parse(this.sessionStorageWithFallback.getItem(key));
      } else if (this.localStorageWithFallback) {
        data = JSON.parse(this.localStorageWithFallback.getItem(key));
      }
    }
    return data;
  }

  private safeLocalStorage() {
    try {
      const test = '__test__';
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return localStorage;
    } catch (e) {
      return null;
    }
  }

  private safeSessionStorage() {
    try {
      const test = '__test__';
      sessionStorage.setItem(test, test);
      sessionStorage.removeItem(test);
      return sessionStorage;
    } catch (e) {
      return null;
    }
  }
}
